import palette from "./palette";
import typography from "./typography";
import overrides from "./overrides";
import { createTheme } from "@mui/material/styles";

const theme = createTheme({
  palette,
  typography,
  overrides,
  components: {
    MuiTextField: {
      defaultProps: {
        size: "small",
      },
    },
  },
});

export default theme;
